export default __webpack_public_path__ + "static/media/rightBottomEaster.1427b3b2.png";